export const categories = {
  sample: { name: 'サンプル', color: '#d6bd6b', path: 'sample' },
  management: { name: '経営', color: '#166faa', path: 'management' },
  humanresource: { name: 'サンプル', color: '#47b380', path: 'humanresoure' },
  highschool: { name: '高校入試', color: '#791864', path: 'highschool' },
  university: { name: '大学入試', color: '#491783', path: 'university' },
  advertisement: { name: '広告', color: '#d6bd6b', path: 'advertisement' },
  production: { name: '制作', color: '#5ca4b3', path: 'production' },
}
